import React from 'react'

export type Props = {
  name: string
  width: number
  children?: (value: any) => React.ReactNode
  noLabel?: boolean
  grow?: number
}

function ReportsTableColumn(_props: Props) {
  return null
}

export default ReportsTableColumn
